import { IHttpService } from "../HttpService";
import PositionType, { IPositionType } from "../../model/position/PositionType";
import { formatBooleanValue, parseBooleanValue } from "../..";

export interface IPositionTypeService {
  getPositionTypes(): Promise<IPositionType[]>;
  createPositionType(positionType: IPositionType): Promise<any>;
  updatePositionType(positionType: IPositionType);
}

const PositionTypeService = (httpService): IPositionTypeService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api/codebooks";
  const _positionTypesPath = "position-types";

  let PositionTypeListMapper = (json = []) => {
    return json.map((item: any) => {
      let positionType = PositionType(item);
      positionType.valid = formatBooleanValue(item.valid);
      return positionType;
    });
  };

  let ParamsMapper = (positionType: IPositionType) => {
    return {
      id: positionType.id,
      name: positionType.name,
      valid: parseBooleanValue(positionType.valid),
      dataSource: positionType.dataSource
    };
  };

  return {
    async getPositionTypes() {
      const path = _http.buildPath(_baseUrl, _positionTypesPath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return PositionTypeListMapper(responseJSON);
    },

    async createPositionType(positionType: IPositionType) {
      const path = _http.buildPath(_baseUrl, _positionTypesPath);
      const response = await _http.post(path, {
        params: ParamsMapper(positionType)
      });
      return _http.toText(response);
    },

    async updatePositionType(positionType: IPositionType) {
      const path = _http.buildPath(
        _baseUrl,
        _positionTypesPath,
        positionType.id.toString()
      );
      const response = await _http.put(path, {
        params: ParamsMapper(positionType)
      });
      return _http.toText(response);
    }
  };
};

export default PositionTypeService;
